import { NGSModuleMetadata } from "~/core/module";

export const ModuleKeys = {
  HEADER: "header",
  HANDBOOK: "handbook",
} as const;

export type ModuleKey = (typeof ModuleKeys)[keyof typeof ModuleKeys];

export const NGSModules: { [key: string]: NGSModuleMetadata } = {
  header: {
    name: "Header Enhancements",
    accessor: ModuleKeys.HEADER,
    dependencies: [],
    description: "This modules contains header enhancements",
  },
  handbook: {
    name: "Handbook",
    accessor: ModuleKeys.HANDBOOK,
    dependencies: [],
    routes: ["/handbook", "/handbook/"],
    description: "This modules contains the handbook enhancements",
  },
};
